const url = ()=>({
    apiNasa:"https://api.nasa.gov/planetary/apod?count=1&api_key=zbZ3Oujd8fiptxK3rdbOFecqgVFHdnDQujmkveLS",
})

export default url;